module.exports = __webpack_public_path__ + "img/paper_speaking.50a68e8e.png";